<section id="landing_aceptacion-usuario" class="landing-bienvenida" [class.landing-bienvenida--juridica]="isJuridica">
  <app-header-public variant="v2" [showAuthButtons]="true" [showRegisterButton]="false" [showPartnerLogo]="false"
    [loginRouterLink]="'/microempresario/login'"></app-header-public>

  <div class="landing-bienvenida__vigilado" aria-hidden="true">
    <img class="landing-bienvenida__vigilado-img" src="assets/img/Home/hero/Ico_super.svg" alt="" />
  </div>

  <main class="landing-bienvenida__main">
    <section class="landing-bienvenida__hero">
      <div class="landing-bienvenida__overlay">
        <div class="landing-bienvenida__overlay-head">
          <h1 class="landing-bienvenida__name">{{ displayName }}</h1>

          <p class="landing-bienvenida__welcome">
            ¡Te damos la bienvenida a
            <span class="landing-bienvenida__brand">neocrédito</span>!
          </p>
        </div>

        <p class="landing-bienvenida__lead">
          Ahora podrás solicitar tu crédito con facilidad
        </p>

        <ul class="landing-bienvenida__benefits" aria-label="Beneficios neocrédito">
          @for (item of benefits; track item.titulo) {
          <li class="landing-bienvenida__benefit">
            <img class="landing-bienvenida__benefit-icon" [src]="item.icon" alt="" width="48" height="48" />
            <div class="landing-bienvenida__benefit-body">
              <h2 class="landing-bienvenida__benefit-title">{{ item.titulo }}</h2>
              <p class="landing-bienvenida__benefit-text">{{ item.texto }}</p>
            </div>
          </li>
          }
        </ul>

        <div class="landing-bienvenida__cta">
          <button type="button" class="landing-bienvenida__btn" id="btn-landing-inicia-sesion" (click)="goToLogin()">
            Inicia sesión
          </button>
        </div>
      </div>

      <div class="landing-bienvenida__media" aria-hidden="true">
        <picture>
          <source media="(max-width: 767.98px)" [attr.srcset]="portraitSrcMobile" />
          <img class="landing-bienvenida__portrait" [src]="portraitSrc"
            [alt]="isJuridica ? 'Persona jurídica' : 'Persona natural'" />
        </picture>
      </div>
    </section>
  </main>

  <app-home-site-footer></app-home-site-footer>
</section>